import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { b as breakpoints } from './index5.js';
import { D as DomService } from './index3.js';
import { a as ButtonAppearance, b as ButtonType, d as defineCustomElement$a } from './roche-button2.js';
import './index2.js';
import { C as CookieService } from './index11.js';
import { d as defineCustomElement$9 } from './roche-column2.js';
import { d as defineCustomElement$8 } from './roche-columns2.js';
import { d as defineCustomElement$7 } from './roche-container2.js';
import { d as defineCustomElement$6 } from './roche-grid2.js';
import { d as defineCustomElement$5 } from './roche-headline2.js';
import { d as defineCustomElement$4 } from './roche-icon2.js';
import { d as defineCustomElement$3 } from './roche-select2.js';
import { d as defineCustomElement$2 } from './roche-tooltip2.js';

const rocheOnLoadNoticeCss = ":host{display:block;margin-top:3rem;z-index:350;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.5);margin:0;display:flex;align-items:center;justify-content:center;overflow-y:auto;opacity:0;pointer-events:none;padding:1rem}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 90rem){:host{margin-top:0}}:host>roche-grid{width:100%}:host .wrapper{background-color:#fff;background-clip:border-box;padding:2.5rem 1.25rem;overflow-y:auto;max-height:calc(100vh - 2.5rem * 2)}@media (min-width: 48rem){:host .wrapper{padding:4rem 2rem}}:host roche-headline{margin-top:0}:host .button-wrapper{display:block;margin-top:1.5rem}@media (min-width: 48rem){:host .button-wrapper{display:flex;justify-self:center;padding:1.5rem 0 0 0;margin:1rem 0 0 0}}@media (min-width: 64rem){:host .button-wrapper{padding:0}}:host .button-wrapper roche-button{width:100%}:host .button-wrapper roche-button:last-child{margin-top:1rem}@media (min-width: 48rem){:host .button-wrapper roche-button{margin-top:0}:host .button-wrapper roche-button:last-child{margin-top:0}:host .button-wrapper roche-button:first-child{margin-right:1rem}}:host roche-select{display:flex;margin-top:1rem}@media (min-width: 48rem){:host roche-select{margin-top:1.5rem}}:host roche-grid{position:fixed;top:0;margin-top:2.5rem;padding:0 1.25rem}@media (min-width: 48rem){:host roche-grid{margin-top:7.5rem}}::slotted(roche-richtext){margin-top:0 !important}:host([open]){opacity:1;pointer-events:auto;transition:0.6s opacity 0.6s}@media (min-width: 48rem){:host([dir=rtl]) .button-wrapper roche-button:first-child{margin-left:1rem;margin-right:0}}";
const RocheOnLoadNoticeStyle0 = rocheOnLoadNoticeCss;

const cookieValue = 'accepted';
const RocheOnLoadNotice$1 = /*@__PURE__*/ proxyCustomElement(class RocheOnLoadNotice extends HTMLElement {
    handleSelectCheck({ detail }) {
        this.checkedSelect = detail.isAnythingSelected;
    }
    handleResize() {
        this.isMobile = window.innerWidth <= breakpoints.medium;
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.open = false;
        this.hideNoticeCheckbox = false;
        this.noticeText = undefined;
        this.confirmButtonText = undefined;
        this.cancelButtonText = undefined;
        this.dontShowMessageText = undefined;
        this.redirectLink = undefined;
        this.uid = undefined;
        this.checkedSelect = false;
        this.isMobile = false;
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleContinueClick = this.handleContinueClick.bind(this);
    }
    hasUserSavedPreferences() {
        return CookieService.getCookie(`onLoadNotice${this.cookieId}`) === cookieValue;
    }
    get cookieId() {
        return this.uid
            // Fallback to an id generated from the active URL
            || encodeURI(window.location.href.replace(window.location.origin, ''))
                .replace(/[^a-zA-Z0-9]/g, '');
    }
    async componentWillLoad() {
        if (this.hideNoticeCheckbox) {
            CookieService.removeCookie(`onLoadNotice${this.cookieId}`);
        }
        if (this.hasUserSavedPreferences()) {
            return;
        }
        this.handleResize();
        this.open = true;
    }
    componentDidLoad() {
        this.handleResize();
        DomService.handleTextDirection(this.element);
    }
    render() {
        return (h(Host, { key: '8b60c494e97557634a0f4149b6621df45dbaac6d' }, h("roche-grid", { key: '3af2a9491478c2bfc370b87a4a46404efdcebedc', layout: '10' }, h("div", { key: '7a933d042709ee2a3b5a78970aa67cf12e458a2e', class: "wrapper" }, h("div", { key: 'cf5f28efe03fb75956d9b64b6373dc5ad59543ac' }, h("slot", { key: '5b733110357796d2a7b022276a77d757ef70222e' }, h("roche-headline", { key: '5a2effc1a0719d2433c2482910fb2cb1a1c331df', headline: this.noticeText, level: this.isMobile ? 6 : 4 })), !this.hideNoticeCheckbox && h("roche-select", { options: `[{"label":"${this.dontShowMessageText}","value":"hide-on-load-notice"}]`, "multi-select": true, labelWrapper: true })), h("div", { key: '3b489de46a87ff871b98cfb9faba12d5bd427ce0', class: "button-wrapper" }, h("roche-button", { key: '750cb24f326971eec9ce3a70ea831193f0d5669a', appearance: ButtonAppearance.SECONDARY, text: this.cancelButtonText, type: ButtonType.BUTTON, href: this.redirectLink, onRocheButtonClick: this.handleCancelClick }), h("roche-button", { key: '7ae5f47c9e9d0f93d487c1877e72bbb96284faa0', text: this.confirmButtonText, type: ButtonType.BUTTON, onRocheButtonClick: this.handleContinueClick }))))));
    }
    handleCancelClick() {
        this.open = false;
    }
    handleContinueClick() {
        this.open = false;
        if (CookieService.getConsent().necessary && this.checkedSelect) {
            CookieService.setCookie(`onLoadNotice${this.cookieId}`, cookieValue, { expires: 182 });
        }
    }
    get element() { return this; }
    static get style() { return RocheOnLoadNoticeStyle0; }
}, [1, "roche-on-load-notice", {
        "open": [1540],
        "hideNoticeCheckbox": [4, "hide-notice-checkbox"],
        "noticeText": [1, "notice-text"],
        "confirmButtonText": [1, "confirm-button-text"],
        "cancelButtonText": [1, "cancel-button-text"],
        "dontShowMessageText": [1, "dont-show-message-text"],
        "redirectLink": [1, "redirect-link"],
        "uid": [1],
        "checkedSelect": [32],
        "isMobile": [32]
    }, [[0, "rocheFormControlChange", "handleSelectCheck"], [9, "resize", "handleResize"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-on-load-notice", "roche-button", "roche-column", "roche-columns", "roche-container", "roche-grid", "roche-headline", "roche-icon", "roche-select", "roche-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-on-load-notice":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheOnLoadNotice$1);
            }
            break;
        case "roche-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "roche-column":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "roche-columns":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "roche-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "roche-grid":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "roche-headline":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "roche-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheOnLoadNotice = RocheOnLoadNotice$1;
const defineCustomElement = defineCustomElement$1;

export { RocheOnLoadNotice, defineCustomElement };

//# sourceMappingURL=roche-on-load-notice.js.map